<script setup lang="ts">
import { NxtTextEditor } from '@future-harry/nxt-styles';
import LanguageTabs from '@/core/components/layout-elements/LanguageTabs.vue';

const model = defineModel<any>();

const props = defineProps<{
   errors: Record<string, string>;
}>();
</script>

<template>
   <LanguageTabs :errors="props.errors" v-slot="{ activeLanguageName }">
      <NxtTextEditor
         v-if="activeLanguageName"
         v-plain-text-paste
         :name="`text.${activeLanguageName}`"
         :key="`text.${activeLanguageName}`"
         :hidden-options="['align', 'font-size', 'list', 'emojis', 'reset-style', 'link']"
         :min-height="'15rem'"
         :errors="props.errors"
         v-model="model.text[activeLanguageName]"
      />
   </LanguageTabs>
</template>
